import React, { useState, useRef, useEffect } from "react";
import {
  Modal,
  Form,
  Row,
  Col,
  Overlay,
  Popover,
  Button,
} from "react-bootstrap";
import ReactSelect from "react-select";
import "bootstrap/dist/css/bootstrap.min.css";
import Flatpickr from "react-flatpickr";
import { fetchCityData, selectCity } from "../../redux/actions/citiesAction";
import {
  fetchIndustryData,
  setSelectedIndustry,
} from "../../redux/actions/industryActions";
import { useDispatch, useSelector } from "react-redux";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";

import { customStyles } from "../../selectStyles";
import axios from "../../API/axios";
import toast from "react-hot-toast";
import moment from "moment";
import {
  fetchSpecialization,
  selectSpecialization,
} from "../../redux/actions/specializationAction";
import {
  fetchQualification,
  selectQualification,
} from "../../redux/actions/qualificationAction";
import { useParams } from "react-router-dom";
import {
  fetchInstituteData,
  selectGetInstitute,
} from "../../redux/actions/getInstitutesAction";

const EditEducation = ({
  show,
  handleClose,
  userEducation,
  userDataId,
  userDataInfo,
  getUserCv,
}) => {
  const sessionId = localStorage.getItem("sessionId");
  const { CandidateId } = useParams();
  const userType = localStorage.getItem("userType");
  console.log("user Education1", userEducation);
  const [display, setDisplay] = useState(false);

  const [institution, setInstitution] = useState(null);
  const [city, setCity] = useState(null);
  const [field, setField] = useState("");
  const [degree, setDegree] = useState("");
  const [grade, setGrade] = useState("");
  const [isPresent, setIsPresent] = useState(false);
  const [startYear, setStartYear] = useState("");
  const [endYear, setEndYear] = useState("");
  const [description, setDescription] = useState("");
  const [activities, setActivities] = useState("");

  const [showTooltip, setShowTooltip] = useState(false);
  const targetRef = useRef(null);
  const [newEducation, setNewEducation] = useState("");
  const [OrganizationName, setOrganizationName] = useState("");

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [industryDataName, setIndustryDataName] = useState("");
  const [qualification, setqualification] = useState("");
  // const [cityId, setCityId] = useState("");
  const [cityName, setCityName] = useState("");
  const [specilization, setspecilization] = useState("");
  console.log("userEducation", userEducation);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisplay(true);
    const body = {
      sessionId: sessionId,
      userDataId: userDataId,
      userType: userType,
      instnCnddtID: CandidateId === "Candidate" ? null : CandidateId,
      institutionId: industryDataId,
      orgType: industryDataId === null ? newOrgType : orgType,
      gnrlOrgInsttnId: getOrgInsTId,
      field: field,
      degree: degree,
      startYear: startDate === "" ? "" : moment(startDate).format("YYYY"),
      endYear: endDate === "" ? "" : moment(endDate).format("YYYY"),
      qualification: qualificationId,
      specilization: specializationId,
      grade: grade,
      activities: activities,
      description: description,
      cityId: cityId,
      startMonth: startDate === "" ? "" : moment(startDate).format("MM"),
      isPresent: isPresent,
      endMonth: endDate === "" ? "" : moment(endDate).format("MM"),
      eduId: 1,
    };
    console.log("update body", body);
    if (
      (industryDataId === "" && getOrgInsTId === "") ||
      (orgType === "" && newOrgType === "") ||
      degree === "" ||
      field === "" ||
      cityId === null ||
      cityId === "" ||
      startDate === ""
    ) {
      toast.error("Please fill all the required fields");
    } else {
      try {
        const res = await axios.post("/Resume/UpdateEducation", body);
        console.log("updateres=====>", res);

        toast.success(res.data.message);
        handleClose();
        getUserCv();
        setDisplay(false);
      } catch (error) {
        if (error.response && error.response.status === 404) {
          toast.warning(error.response.data.message);
        } else {
          toast.error(error.response?.data?.message || "An error occurred");
        }
      }
    }
  };

  // ...............................City DDL.......................................
  const dispatch = useDispatch();
  const [cityId, setCityId] = useState();
  const { cityList, selectedcityId } = useSelector((state) => state.cities);
  useEffect(() => {
    dispatch(fetchCityData());
  }, [dispatch]);
  const handleCitySelect = (selectedOption) => {
    // console.log("selectedOption", selectedOption);

    if (selectedOption) {
      // dispatch(selectCity(selectedOption.value));
      setCityId(selectedOption.value);
    }
  };

  // ...............................City DDL.......................................
  // ...............................Industry DDL.......................................
  // const [industryId, setIndustryId] = useState(null);
  const { industryList, selectedIndustryId } = useSelector(
    (state) => state.industry
  );
  useEffect(() => {
    dispatch(fetchIndustryData());
  }, [dispatch]);
  const handleIndustrySelect = (val) => {
    dispatch(setSelectedIndustry(val.value));
  };
  // ...............................Industry DDL.......................................
  const [orgCity, setOrgCity] = useState(null);

  const toggleTooltip = () => {
    console.log("Toggling Tooltip");
    setShowTooltip((prev) => !prev);
  };

  const handleCitySelect1 = (selectedOption) => {
    if (selectedOption) {
      setOrgCity(selectedOption.value);
    }
  };

  const [newOrgType, setnewOrgType] = useState(null);

  const [fileName, setFileName] = useState("");
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setFileName(file.name);
    }
  };
  const [getOrgInsTId, setGenOrgInstId] = useState(null);

  const handleSaveInstitution = async () => {
    // setDisplay(true);

    const formData = new FormData();
    formData.append("orgName", OrganizationName);
    formData.append("OrgType", "UnRegdInstitution");
    formData.append("CityID", orgCity);
    formData.append("OrgLogo", fileName);
    formData.append("sessionId", sessionId);
    console.log("formData", formData);

    try {
      const res = await axios.post("/CandidateData/AddGnrlOrgData", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      console.log("res", res);
      setGenOrgInstId(res.data.responseData.id);
      setnewOrgType(res.data.responseData.value);
      toast.success(res.data.message);
      setShowTooltip(false);
      setOrganizationName("");
      setOrgCity(null);
      setFileName("");
    } catch (error) {
      if (error.response && error.response.status === 404) {
        toast.warning(error.response.data.message);
      } else {
        toast.error(error.response?.data?.message || "An error occurred");
      }
    }
  };

  // ...............................Specialization DDL.......................................
  const [specializationId, setSpecilizationId] = useState("");
  const { SpecializationList, selectedSpecializationId } = useSelector(
    (state) => state.specialization
  );
  useEffect(() => {
    dispatch(fetchSpecialization());
  }, [dispatch]);

  const handleSpecializationSelect = (selectedOption) => {
    if (selectedOption) {
      // dispatch(selectSpecialization(selectedOption.label));
      setSpecilizationId(selectedOption.label);
    }
  };

  // ...............................Qualification DDL.......................................
  const [qualificationId, setqualificationId] = useState("");

  const { qualficationList, selectedqualficationId } = useSelector(
    (state) => state.qualification
  );
  useEffect(() => {
    dispatch(fetchQualification());
  }, [dispatch]);
  const handleQualificationSelect = (selectedOption) => {
    if (selectedOption) {
      setqualificationId(selectedOption.label);
      // dispatch(selectQualification(selectedOption.label));
    }
  };

  // ...............................Industry DDL.......................................
  const [orgType, setOrgType] = useState("");
  const [industryDataId, setIndustryDataId] = useState(null);

  const { getinstituteList, selectedinstituteId } = useSelector(
    (state) => state.institute
  );
  useEffect(() => {
    dispatch(fetchInstituteData());
  }, [dispatch]);

  const handleInstitute = (selectedOption) => {
    if (selectedOption) {
      dispatch(selectGetInstitute(selectedOption.value));
      setIndustryDataId(selectedOption.value);
      setOrgType(selectedOption.tag);
    }
  };

  useEffect(() => {
    if (userEducation) {
      setIndustryDataId(userEducation?.institutionId);
      setIndustryDataName(userEducation?.institutionName);
      setOrgType(userEducation?.orgTypeId);
      setDegree(userEducation?.degree);
      setField(userEducation?.field);
      setqualification(userEducation?.qualification);
      setspecilization(userEducation?.specilization);
      setGrade(userEducation?.grade);
      setActivities(userEducation?.activities);
      setCityId(userEducation?.cityId);
      setCityName(userEducation?.cityName);
      setDescription(userEducation?.description);
      setIsPresent(userEducation.isPresent);
      setStartDate(userEducation.startYear, userEducation.startMonth);
      setEndDate(userEducation.endYear, userEducation.endMonth);
    }
  }, [userEducation]);

  console.log("industryDataId", industryDataId, userEducation);
  const [InsName, setInsName] = useState("");

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header>
        <Modal.Title>Update Education</Modal.Title>
        <CloseSharpIcon className="pointer" onClick={handleClose} />
      </Modal.Header>
      <Modal.Body className="settings">
        <Row>
          {/* Institution and City */}
          <Col md={6}>
            <Form.Group controlId="institution">
              <Form.Group controlId="Industry">
                <Form.Label className="class-type">
                  Institute
                  <span style={{ color: "red" }} className="ms-2">
                    *
                  </span>
                </Form.Label>
                {InsName !== "" ? (
                  <div>
                    <input
                      type="text"
                      value={InsName}
                      placeholder="Enter Institute name"
                      className="mb-2 form-control"
                      disabled
                    />
                  </div>
                ) : (
                  <div className="post-form-group mb-0">
                    <ReactSelect
                      options={getinstituteList}
                      onChange={handleInstitute}
                      value={
                        getinstituteList.find(
                          (option) => option.value === industryDataId
                        ) || null
                      }
                      onInputChange={(inputValue) => {
                        setIndustryDataName(inputValue);
                      }}
                      placeholder="Select Institute"
                      classNamePrefix="react-select"
                      className="form-control"
                      styles={customStyles}
                    />
                    {display && !industryDataName ? (
                      <span className="error_msg_lbl">Select Institute </span>
                    ) : null}
                  </div>
                )}
              </Form.Group>
              {display && !industryDataId ? (
                <span className="error_msg_lbl">Select Institute </span>
              ) : null}
              <a
                href="#"
                ref={targetRef}
                onClick={(e) => {
                  e.preventDefault();
                  toggleTooltip();
                }}
                className="createModal"
                // isDisabled={!selectedIndustryId} // Disable until industry is selected
              >
                Create New
              </a>
              <Overlay
                target={targetRef.current}
                show={showTooltip}
                placement="right"
                rootClose
                container={document.querySelector(".modal")}
                onHide={() => setShowTooltip(false)} // Close when clicking outside
              >
                <Popover id="popover-basic">
                  <Popover.Header as="h3">Create Organization</Popover.Header>
                  <Popover.Body>
                    <Form>
                      <div>
                        <label className="mb-1">Org name</label>
                        <input
                          type="text"
                          value={OrganizationName}
                          onChange={(e) => {
                            setOrganizationName(e.target.value);
                            setInsName(e.target.value);
                          }}
                          placeholder="Enter Org name"
                          className="mb-2 form-control"
                        />
                      </div>
                      <div>
                        <label className="mb-1">City</label>
                        <ReactSelect
                          options={cityList}
                          onChange={handleCitySelect1}
                          value={
                            cityList.find(
                              (option) => option.value === orgCity
                            ) || null
                          }
                          placeholder="Select City"
                          classNamePrefix="react-select"
                          className="form-control"
                          styles={customStyles}
                        />
                      </div>
                      <div className=" mt-2 mb-2">
                        <label className="mb-1">Org Logo</label>
                        <input
                          type="file"
                          id="lastName"
                          className="form-control"
                          placeholder=""
                          onChange={handleFileChange}
                          //   onChange={(e) => {
                          //     handleProfileImageChange(e);
                          //   }}
                          //   invalid={displays && profileImage === ""}
                        />
                        {/* {displays && !profileImage ? (
                          <span className="error_msg_lbl text-red">
                            Upload Image{" "}
                          </span>
                        ) : null} */}
                      </div>
                      <div className="d-flex justify-content-end">
                        <Button
                          variant="primary"
                          size="sm"
                          onClick={handleSaveInstitution}
                          className="me-2"
                        >
                          Save
                        </Button>
                        <Button
                          variant="secondary"
                          size="sm"
                          onClick={() => setShowTooltip(false)}
                        >
                          Cancel
                        </Button>
                      </div>
                    </Form>
                  </Popover.Body>
                </Popover>
              </Overlay>
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group controlId="city">
              <Form.Label className="class-type">
                City
                <span style={{ color: "red" }} className="ms-2">
                  *
                </span>
              </Form.Label>
            </Form.Group>
            <div className="post-form-group mb-0">
              <ReactSelect
                options={cityList}
                onChange={handleCitySelect}
                value={
                  cityList.find((option) => option.value === cityId) || null
                }
                placeholder="Select City"
                classNamePrefix="react-select"
                className="form-control"
                styles={customStyles}
              />
            </div>
            {display && !cityId ? (
              <span className="error_msg_lbl">Select City </span>
            ) : null}
          </Col>

          {/* Field, Degree, and Grade */}
          <Col md={6} className="mb-2">
            <Form.Group controlId="field">
              <Form.Label className="class-type">
                Field <span style={{ color: "red" }}>*</span>
              </Form.Label>
              <Form.Control
                type="text"
                value={field}
                onChange={(e) => setField(e.target.value)}
                placeholder="Enter Field of Study"
              />
            </Form.Group>
            {display && !field ? (
              <span className="error_msg_lbl">Select Field </span>
            ) : null}
          </Col>
          <Col md={6}>
            <Form.Group controlId="degree">
              <Form.Label className="class-type">
                Degree <span style={{ color: "red" }}>*</span>
              </Form.Label>
              <Form.Control
                type="text"
                value={degree}
                onChange={(e) => setDegree(e.target.value)}
                placeholder="Enter Degree"
              />
              {display && !degree ? (
                <span className="error_msg_lbl">Select Degree </span>
              ) : null}
            </Form.Group>
          </Col>
          <Col md={6} className="mb-2">
            <Form.Group controlId="grade">
              <Form.Label className="class-type">Grade</Form.Label>
              <Form.Control
                type="text"
                value={grade}
                onChange={(e) => setGrade(e.target.value)}
                placeholder="Enter Grade"
              />
            </Form.Group>
          </Col>

          {/* Start Year, End Year, Is Present */}
          <Col md={6}>
            <Form.Group controlId="grade">
              <Form.Label className="class-type">Activites</Form.Label>
              <Form.Control
                type="text"
                value={activities}
                onChange={(e) => setActivities(e.target.value)}
                placeholder="Enter Activites"
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group controlId="city">
              <Form.Label className="class-type">Specialization</Form.Label>
            </Form.Group>
            <div className="post-form-group">
              <ReactSelect
                options={SpecializationList}
                onChange={handleSpecializationSelect}
                value={
                  SpecializationList.find(
                    (option) => option.label === specializationId
                  ) || null
                }
                placeholder="Select Specialization"
                classNamePrefix="react-select"
                className="form-control"
                styles={customStyles}
              />
            </div>
          </Col>
          <Col md={6}>
            <Form.Group controlId="city">
              <Form.Label className="class-type">Qualification</Form.Label>
            </Form.Group>
            <div className="post-form-group">
              <ReactSelect
                options={qualficationList}
                onChange={handleQualificationSelect}
                value={
                  qualficationList.find(
                    (option) => option.label === qualificationId
                  ) || null
                }
                placeholder="Select Qualification"
                classNamePrefix="react-select"
                className="form-control"
                styles={customStyles}
              />
            </div>
          </Col>

          <Col md={6} className="mb-2">
            <Form.Group controlId="endYear">
              <Form.Label className="class-type">
                Start Year
                <span style={{ color: "red" }} className="ms-2">
                  *
                </span>
              </Form.Label>
              <Flatpickr
                type="number"
                value={startDate}
                onChange={(date) => setStartDate(date[0])}
                placeholder="Enter start Year"
                // disabled={isPresent}
              />
              {display && !startDate ? (
                <span className="error_msg_lbl">Enter Start Year</span>
              ) : null}
            </Form.Group>
          </Col>

          {userDataInfo.isPresentEducation === true && isPresent === false ? (
            ""
          ) : (
            <Col md={6} className="d-flex align-items-center">
              <Form.Check
                type="checkbox"
                label="Is Present"
                checked={isPresent}
                onChange={(e) => setIsPresent(e.target.checked)}
              />
            </Col>
          )}

          {isPresent === false ? (
            <Col md={6} className="mb-2">
              <Form.Group controlId="endYear">
                <Form.Label className="class-type">End Year</Form.Label>
                <Flatpickr
                  type="number"
                  value={endDate}
                  onChange={(date) => setEndDate(date[0])}
                  placeholder="Enter End Year"
                  disabled={isPresent}
                  options={{
                    minDate: startDate || null, // Set minDate to startDate
                  }}
                />
              </Form.Group>
            </Col>
          ) : (
            ""
          )}

          {/* Description */}
          <Col md={12}>
            <Form.Group controlId="description">
              <Form.Label className="class-type">Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Enter Description"
              />
            </Form.Group>
          </Col>
        </Row>

        {/* Submit Button */}
        <div className="d-flex justify-content-end mt-4">
          {/* <Button variant="secondary" onClick={handleClose} className="me-3">
                        Close
                    </Button> */}
          <div className="add-class-submit-button mt-4 d-flex justify-content-center">
            <div className="khojPrimaryBtn ms-3">
              <a href="#/" className="" onClick={handleSubmit}>
                Submit
              </a>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default EditEducation;
